import { z } from 'zod';

export const ChartModelItemSchema = z
  .object({
    id: z.number(),
    name: z.string(),
    caption: z.string().optional(),
  })
  .transform((raw) => ({
    key: String(raw.id),
    value: raw.name,
    subtitle: raw.caption,
  }));

export const ChartModelsSchema = z.array(ChartModelItemSchema);

export type ChartModels = z.output<typeof ChartModelsSchema>;
export type ChartModelsApi = z.input<typeof ChartModelsSchema>;
